export const Movies = [
  {
    name: 'Army Of  The Dead',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '1a.jpg',
    image: '1.jpg',
    category: 'Western',
    language: 'English',
    year: '2022',
    time: '3hr',
    video: '',
    rate: 3.4,
    reviews: 23,
  },
  {
    name: 'The Conjuring',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '22.jpeg',
    image: '2.jpeg',
    category: 'Thriller',
    language: 'Chinese',
    year: '1999',
    time: '4hr',
    video: '',
    rate: 5,
    reviews: 100,
  },
  {
    name: 'My Favorite Person',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '33.jpg',
    image: '3.jpg',
    category: 'Adventure',
    language: 'Korean',
    year: '2000',
    time: '11hr',
    video: '',
    rate: 2.5,
    reviews: 2,
  },
  {
    name: 'Lets Be a crops',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '44.jpg',
    image: '4.jpg',
    category: 'Musicals',
    language: 'English',
    year: '2022',
    time: '5hr',
    video: '',
    rate: 1.5,
    reviews: 6,
  },
  {
    name: 'Below her mouth',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '55.jpg',
    image: '5.jpg',
    category: 'Romantic',
    language: 'English',
    year: '1899',
    time: '1hr',
    video: '',
    rate: 5,
    reviews: 56,
  },
  {
    name: 'Legend of the seeker',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '66.jpg',
    image: '6.jpg',
    category: 'Horror',
    language: 'Swahili',
    year: '2012',
    time: '19hr',
    video: '',
    rate: 4.5,
    reviews: 34,
  },
  {
    name: 'Scarlet Heart',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '77.jpg',
    image: '7.png',
    category: 'Fantasy',
    language: 'Korean',
    year: '2005',
    time: '4hr',
    video: '',
    rate: 0,
    reviews: 0,
  },
  {
    name: 'The Last Dance',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '88.jpg',
    image: '8.jpg',
    category: 'Sports',
    language: 'Japanese',
    year: '1999',
    time: '6hr',
    video: '',
    rate: 0.5,
    reviews: 0,
  },
  {
    name: 'Titanic',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '99.jpg',
    image: '9.jpg',
    category: 'Drama',
    language: 'Swahili',
    year: '2012',
    time: '4hr',
    video: '',
    rate: 1,
    reviews: 1,
  },
  {
    name: 'About Time of the Dead',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '101.jpg',
    image: '10.jpg',
    category: 'Comedy',
    language: 'French',
    year: '2000',
    time: '1hr',
    video: '',
    rate: 0,
    reviews: 4,
  },
  {
    name: 'Game of Thrones',
    desc: 'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
    titleImage: '111.webp',
    image: '11.jpg',
    category: 'Action',
    language: 'Chinese',
    year: '2012',
    time: '9hr',
    video: '',
    rate: 1,
    reviews: 6,
  },
];

export const UsersData = [
  {
    fullName: 'Tom Cruise',
    image: 'c1.png',
    email: 'tomcruise@gmail.com',
    rate: 4.5,
    message:
      'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
  },
  {
    fullName: 'Emily Blunt',
    image: 'c2.png',
    email: 'emilyblunt@gmail.com',
    rate: 0.5,
    message:
      'There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
  },
  {
    fullName: 'John Snow',
    image: 'c3.png',
    email: 'johnsnow@gmail.com',
    rate: 2.5,
    message: 'The majority have suffered alteration.',
  },
  {
    fullName: 'Will Smith',
    image: 'c4.png',
    email: 'willsmith@gmail.com',
    rate: 5,
    message:
      'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
  },
  {
    fullName: 'Minah Lee',
    email: 'minahlee@gmail.com',
    image: 'c5.png',
    rate: 1.5,
    message:
      'Lorem ipsum dolor sit amet, consecetur adipiscing elseddo eiusmod There are many variations of passages of lorem Ipsum available, but the majority have suffered alteration.',
  },
];
